/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

function DialogTitle(props) {
    const {
        children,
        className,
        component: Component,
        ...other
    } = props;

    return (
        <Component className={className} {...other}>
            {children}
        </Component>
    );
    // return <Component className={ className } {...other} />;
}

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const DialogTitle = ({prop = val, component = 'span' }) =>

DialogTitle.propTypes = {
    component: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default memo(DialogTitle);
